import React from 'react';
import PaymentsList from './PaymentsList';

export default function Payments() {
  return (
    <section className="Payments">
      <PaymentsList />
    </section>
  );
}
